import { BrandMark } from '@mt/ui';
import { BRAND } from '../config/brand.ts';

/** Shown when the build has no backend configuration. There is deliberately no demo/fake mode. */
export function ConfigMissing() {
  return (
    <main className="grid min-h-dvh place-items-center bg-paper px-4">
      <div className="w-full max-w-lg rounded-2xl border border-line bg-surface p-6 shadow-card sm:p-8">
        <div className="flex items-center gap-2.5">
          <BrandMark />
          <span className="font-display text-xl font-bold">{BRAND.name}</span>
        </div>
        <h1 className="mt-6 text-2xl font-bold">Backend not configured</h1>
        <p className="mt-2 text-muted">
          This build has no Supabase URL or key, so it can’t sign you in or save progress. Set <code className="rounded bg-surface-2 px-1">VITE_SUPABASE_URL</code> and{' '}
          <code className="rounded bg-surface-2 px-1">VITE_SUPABASE_ANON_KEY</code> (see <code className="rounded bg-surface-2 px-1">apps/web/.env.example</code> and the README), then rebuild.
        </p>
      </div>
    </main>
  );
}
